import { RequestResponse } from "@api";
import { Box, Button, Grid } from "@material-ui/core";
import React from "react";
import {
  CLEAR_FILTERS_DATA,
  UPDATE_CUSTOM_FILTER,
  UPDATE_FILTERS_DATA,
} from "../state";
import { TableContext } from "../table";
import { RowWrapper } from "../types";
import {
  Filters,
  filterTable,
  AccessProvisionersFilters,
  Search,
} from "./search-filters";
import { Form } from "@components/index";

const customFilter = (
  rowsWrappers: RowWrapper<RequestResponse>[],
  filterData: Filters
): RowWrapper<RequestResponse>[] => {
  return rowsWrappers.filter((wrapper) => {
    return filterTable(wrapper.row.data, filterData);
  });
};

export const AccessProvisionersToolbar: React.FC = () => {
  const { state, dispatch } = React.useContext(TableContext);
  const { rows } = state;
  const [open, setOpen] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const form = Form.useManager<Filters>({
    environment: "",
    dateType: "",
    status: "",
    systemName: "",
    dateFrom: null,
    dateTo: null,
    typeOfAction: "",
    systemCategory: "",
    systemType: "",
  });

  React.useEffect(() => {
    dispatch({ type: UPDATE_CUSTOM_FILTER, customFilter });
  }, [dispatch]);

  const onSearchUpdate = React.useCallback(
    (term: string) => {
      setSearchValue(term);
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={2}>
        <Grid item container xs={12} justify="flex-end">
          <Grid item xs={3}>
            <Search
              onSearchUpdate={onSearchUpdate}
              placeholder={"AR or RF No."}
              defaultValue={searchValue}
            ></Search>
          </Grid>
        </Grid>
        <Grid item container xs={12} justify="flex-end">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpen(true)}
          >
            Filters
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              dispatch({ type: CLEAR_FILTERS_DATA });
              form.reset();
              setSearchValue("");
            }}
            style={{ marginLeft: "40px" }}
          >
            Reset Filters
          </Button>
        </Grid>
      </Grid>
      <AccessProvisionersFilters
        open={open}
        requests={rows}
        form={form}
        onApply={(filters: Filters) => {
          setOpen(false);
          dispatch({ type: UPDATE_FILTERS_DATA, filtersData: filters });
        }}
        onCancel={() => setOpen(false)}
      />
    </Box>
  );
};
